import { MD5, SHA256 } from 'crypto-js'

/**
 * 密码加盐哈希的固定盐值
 */
const PWD_SALT = '01ac3cc019bf15fab3911e4db3043361'

/**
 * 密码加密：SHA256(MD5(pwd) + salt)
 */
export const encryptPwd = (pwd: string) => SHA256(md5Pwd(pwd) + PWD_SALT).toString()

/**
 * 密码md5：MD5(pwd)
 */
export const md5Pwd = (pwd: string) => MD5(pwd).toString()
